import { render, staticRenderFns } from "./AssignmentToShift.vue?vue&type=template&id=3a00a590"
import script from "./AssignmentToShift.vue?vue&type=script&lang=js"
export * from "./AssignmentToShift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports